<template>
    <main class="main not-found">
        <div class="not-found__descWrapper">
            <h3 class="h3 not-found__desc text-center">
                Trwa pobieranie pliku...
            </h3>
        </div>
        <div>
            <button class="btn btn-secondary" @click="onButtonClick">
                Przejdź {{ token ? 'do pulpitu' : 'do strony logowania' }}
            </button>
        </div>
    </main>
</template>

<script>
export default {
    name: 'FileDownload',
    computed: {
        token() {
            return this.$store.getters.authToken
        }
    },
    methods: {
        onButtonClick() {
            this.$router.push({ name: 'dashboard' })
        }
    }
}
</script>

<style lang="scss" scoped>
.not-found {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding-top: 3rem;
    padding-bottom: 6rem;

    &__descWrapper {
        margin-bottom: 1rem;
    }
    &__title {
        font-size: 8rem;
    }
}
</style>
